import React, { useState, useEffect } from 'react';
import { cihazIDService, cihazBilgiService } from '../api/dbService';
import PageLayout from '../components/PageLayout';
import LoadingSpinner from '../components/LoadingSpinner';

function calculateBattery(pct) {
  if (!pct || pct <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round(pct)));
}

export default function InactiveDevices() {
  const [cihazlar, setCihazlar] = useState([]);
  const [sensorMap, setSensorMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    cihazIDService.getInaktifCihazlar()
      .then(async res => {
        const list = res.data || [];
        setCihazlar(list);
        const map = {};
        await Promise.allSettled(list.map(async c => {
          try {
            const d = await cihazBilgiService.getSonVeri(c.device_id);
            map[c.device_id] = d.data;
          } catch {}
        }));
        setSensorMap(map);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <PageLayout><LoadingSpinner /></PageLayout>;

  return (
    <PageLayout>
      <h5 className="mb-3 fw-semibold">İnaktif Cihazlar</h5>
      <div className="table-responsive">
        <table className="table table-hover table-sm align-middle">
          <thead className="table-light">
            <tr><th>Cihaz Kodu</th><th>Adı</th><th>Durum</th><th>Pil</th><th>Kontör Bitiş</th><th></th></tr>
          </thead>
          <tbody>
            {cihazlar.length === 0 && <tr><td colSpan={6} className="text-center text-muted py-4">İnaktif cihaz yok</td></tr>}
            {cihazlar.map(c => {
              const s = sensorMap[c.device_id];
              const pct = calculateBattery(s?.voltaj);
              const kontor = c.kontor_bitis_tarihi ? new Date(c.kontor_bitis_tarihi) : null;
              const kalanGun = kontor ? Math.ceil((kontor - new Date()) / 86400000) : null;

              return (
                <React.Fragment key={c.id}>
                  <tr>
                    <td><code>{c.device_id}</code></td>
                    <td>{c.cihaz_adi || '—'}</td>
                    <td>
                      <span className={`badge bg-${c.durum === 'aktif' ? 'success' : c.durum === 'bakimda' ? 'warning' : 'secondary'}`}>
                        {c.durum}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-1">
                        <div className="progress" style={{ width: 60, height: 8 }}>
                          <div className={`progress-bar bg-${pct > 50 ? 'success' : pct > 20 ? 'warning' : 'danger'}`} style={{ width: `${pct}%` }} />
                        </div>
                        <small>{pct}%</small>
                      </div>
                    </td>
                    <td>
                      {kontor ? (
                        <span className={kalanGun != null && kalanGun < 5 ? 'text-danger fw-semibold' : ''}>
                          {kontor.toLocaleDateString('tr-TR')}
                          {kalanGun != null && ` (${kalanGun}g)`}
                        </span>
                      ) : '—'}
                    </td>
                    <td>
                      <button className="btn btn-outline-secondary btn-sm" onClick={() => setExpanded(expanded === c.id ? null : c.id)}>
                        {expanded === c.id ? 'Kapat' : 'Detay'}
                      </button>
                    </td>
                  </tr>
                  {expanded === c.id && s && (
                    <tr>
                      <td colSpan={6}>
                        <div className="p-3 bg-light rounded small">
                          <div className="row g-2">
                            {[
                              ['Sıcaklık', s.sicaklik != null ? `${Number(s.sicaklik).toFixed(1)}°C` : '—'],
                              ['Nem', s.nem != null ? `${Number(s.nem).toFixed(1)} %RH` : '—'],
                              ['Pil', s.voltaj != null ? `${Math.round(s.voltaj)}%` : '—'],
                              ['Enlem', s.enlem || '—'],
                              ['Boylam', s.boylam || '—'],
                              ['Son Veri', s.zaman_damgasi ? new Date(s.zaman_damgasi).toLocaleString('tr-TR') : '—']
                            ].map(([k, v]) => (
                              <div key={k} className="col-6 col-md-4">
                                <span className="text-muted">{k}:</span> <strong>{v}</strong>
                              </div>
                            ))}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </PageLayout>
  );
}
